import Svg from '../generated/Moderator';
import { Icon, type IconProps } from './Icon';

export const ModeratorIcon = (props: IconProps) => <Icon component={Svg} name="moderator" {...props} />;
